import React from 'react'
import styles from '../styles/Home.module.css'
import WorkType from './WorkType'

const Home = () => {

    const lorem = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta vero illum neque doloremque repellat, laboriosam optio possimus voluptatum fugiat quidem aliquid velit harum provident recusandae aspernatur aliquam explicabo sint dolor."

    return(
        <main>

            <div className = {styles.overlay}>

                <div className={styles.mainimg }>
                    <h1 className = {styles.h1} >Are you stuck and in need of a plumber!</h1>
                </div>
                
            </div>

            <div className = {styles.home}>

                <h1 className = {styles.welcome}>Welcome to stucko plumbing</h1> 

                <p className = {styles.p} >There comes a time when you get backed up. but dont worry. We are here to help you get flowing.</p>
                
                <p className = {styles.p} >{lorem}</p>

                <p className = {styles.p} >{lorem}</p>

                <p className = {styles.p2} >Take a look at the services we offer:</p>                 

                <WorkType/>  

            </div>
                        
        </main>
    )
}

export default Home